import { render, staticRenderFns } from "./aiGallery.vue?vue&type=template&id=147eee7a&scoped=true&"
import script from "./aiGallery.vue?vue&type=script&lang=js&"
export * from "./aiGallery.vue?vue&type=script&lang=js&"
import style0 from "./aiGallery.vue?vue&type=style&index=0&id=147eee7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147eee7a",
  null
  
)

export default component.exports